import { render, staticRenderFns } from "./Failures.vue?vue&type=template&id=21d223cb&scoped=true&"
import script from "./Failures.vue?vue&type=script&lang=js&"
export * from "./Failures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d223cb",
  null
  
)

export default component.exports